import { render, staticRenderFns } from "./SelectionMatrixQuestion.vue?vue&type=template&id=48d96821&scoped=true&"
import script from "./SelectionMatrixQuestion.vue?vue&type=script&lang=js&"
export * from "./SelectionMatrixQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SelectionMatrixQuestion.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SelectionMatrixQuestion.vue?vue&type=style&index=1&id=48d96821&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d96821",
  null
  
)

export default component.exports